// hooks/useVideoWithSound.js
import { useEffect, useRef } from 'react';
import { useMedia } from '../contexts/MediaContext';

export const useVideoWithSound = (videoProps = {}) => {
  const videoRef = useRef(null);
  const { isMediaUnlocked } = useMedia();

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Garantiza playsInline siempre (crítico en iOS)
    video.setAttribute('playsinline', '');

    const applyState = async () => {
      try {
        if (isMediaUnlocked) {
          video.muted = false;
          video.removeAttribute('muted'); // algunos navegadores conservan el atributo
          video.volume = videoProps.volume ?? 0.8;
          if (videoProps.autoPlay && video.paused) {
            await video.play();
          }
        } else {
          video.muted = true; // hasta que se desbloquee
        }
      } catch (err) {
        console.warn('Error reproduciendo video:', err);
      }
    };

    applyState();

    const onLoaded = () => {
      if (isMediaUnlocked) {
        video.muted = false;
        video.removeAttribute('muted');
        video.volume = videoProps.volume ?? 0.8;
      }
    };
    const onError = () => {
    };

    video.addEventListener('loadedmetadata', onLoaded);
    video.addEventListener('error', onError);
    return () => {
      video.removeEventListener('loadedmetadata', onLoaded);
      video.removeEventListener('error', onError);
    };
  }, [isMediaUnlocked, videoProps.volume, videoProps.autoPlay]);

  return { videoRef, canPlayWithSound: isMediaUnlocked };
};
